import { SubscriptionTypes } from "../types";

export interface CurrentSubscriptionPackageModel {
    type: SubscriptionTypes;
    duration: "month" | "year";
}